import React from 'react';
import './../../../pages/Representante_Instituição/Tela_RI_Cadastro/styles.css';
import { user_token } from '../../../services/Auth';
import api from '../../../services/api'
import { withRouter } from 'react-router-dom'
import { DefaultContext } from 'react-icons/lib';

//import da API
import { professional } from './../../../services/api';
let apiProfessional = new professional();

var boolt = true;
var boolf = false;

var token = localStorage.getItem(user_token);
var professionalID = localStorage.getItem('professional_id')
class Forms_Prontuario_Inicial extends React.Component {
    constructor() {
        super();
        this.state = {
            first: false,
            antecedents: "",
            medications_in_use: "",
            physical_activity: "",
            smoking: "",
            smoking_amount: "",
            alocoholism: "",
            alcoholism_amount: "",
            surgery: "",
            family_history: "",
            current_complaints: "",
            physical_exam: "",
            complementary_exam: "",
            diagnosis: "",
            conduct: "",
            prescripted_drugs: "",
            requested_exams: "",
            medical_referral: "",

            prescription: "",
            status: ""


        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(evt) {
        this.setState({ [evt.target.name]: evt.target.value });
    }

    handleSubmitExam = evt => {
        //evt.preventDefault();
        debugger;
        const exam = {
            date: new Date(),
            prescription: this.state.prescription,
            status: "Realizada",
            professional_id: professionalID,
        };

        //api.patch(`/exam/${this.props.exam_id}`, exam, { headers: { 'x-access-token': token, 'op': 'set' } })
        apiProfessional.editExam(exam, this.props.exam_id, 'set')
            .then(res => {
                console.log(this.props.exam_id);
                console.log(res);
                console.log(res.data);
                alert("Prescrição feita com sucesso!");
                this.props.history.push("/tela_ps_painel");
            })

    }

    handleSubmit = evt => {
        evt.preventDefault();

        const user = {
            date: new Date(),
            first: false,
            medical_record: {
                professional_id: professionalID,
                antecedents: this.state.antecedents,
                medications_in_use: this.state.medications_in_use,
                life_habits: {
                    physical_activity: this.state.physical_activity,
                    smoking: this.state.smoking,
                    smoking_amount: this.state.smoking_amount,
                    alocoholism: this.state.alocoholism,
                    alcoholism_amount: this.state.alcoholism_amount,
                    surgery: this.state.surgery,
                },
                family_history: this.state.family_history,
                current_complaints: this.state.current_complaints,
                physical_exam: this.state.physical_exam,
                complementary_exam: this.state.complementary_exam,
                diagnosis: this.state.diagnosis,
                conduct: this.state.conduct,
                prescripted_drugs: this.state.prescripted_drugs,
                requested_exams: this.state.requested_exams,
                medical_referral: this.state.medical_referral,
            },
        };


        //api.patch(`/user/${this.props.user_id}`, user, { headers: { 'x-access-token': token, 'op': 'set' } })
        debugger;
        apiProfessional.editUser(user, this.props.user_id, 'set')
            .then(res => {
                console.log(this.props.user_id);
                console.log(res);
                console.log(res.data);
                //this.props.history.push("/tela_ps_painel");
            })
        this.handleSubmitExam();
    }

    render() {
        return (
            <>
                <form onSubmit={this.handleSubmit} id="forms-Pront_Init">
                    <h1 id="tittle-forms-cme">Prontuário Inicial</h1>
                    <p id="RI-Title-Cadastro" >Antecedentes:</p>
                    <textarea onChange={this.handleChange} name="antecedents" placeholder="Antecedentes" id="RI-Cadastro" />
                    <p id="RI-Title-Cadastro" >Medicamentos em uso</p>
                    <textarea onChange={this.handleChange} name="medications_in_use" placeholder="Medicamentos em uso" id="RI-Cadastro" />
                    <p type="ratio" id="RI-Title-Cadastro">Pratica atividade física regularmente?</p>
                    <select id="Pront_Init" onChange={this.handleChange} name="physical_activity" required>
                        <option></option>
                        <option value={boolt}>Sim</option>
                        <option value={boolf}>Não</option>
                    </select>
                    <p type="ratio" id="RI-Title-Cadastro">Tabagismo</p>
                    <select id="Pront_Init" onChange={this.handleChange} name="smoking" required>
                        <option></option>
                        <option value={boolt}>Sim</option>
                        <option value={boolf}>Não</option>
                    </select>
                    <p id="RI-Title-Cadastro" >Se a resposta acima for sim, quantos cigarros o paciente fuma por dia?</p>
                    <input onChange={this.handleChange} name="smoking_amount" placeholder="Quantidade de cigarros por dia" id="RI-Cadastro" />
                    <p type="ratio" id="RI-Title-Cadastro">Alcoolismo</p>
                    <select id="Pront_Init" onChange={this.handleChange} name="alocoholism" required>
                        <option></option>
                        <option value={boolt}>Sim</option>
                        <option value={boolf}>Não</option>
                    </select>
                    <p id="RI-Title-Cadastro" >Se a resposta acima for sim, quanto o paciente bebe por dia?</p>
                    <input onChange={this.handleChange} name="alcoholism_amount" placeholder="Quantidade consumida por dia" id="RI-Cadastro" />
                    <p id="RI-Title-Cadastro" >Histórico de Cirurgias:</p>
                    <textarea onChange={this.handleChange} name="surgery" placeholder="Cirurgia" id="RI-Cadastro" />
                    <p id="RI-Title-Cadastro" >Histórico Familiar:</p>
                    <textarea onChange={this.handleChange} name="family_history" placeholder="Histórico Familiar" id="RI-Cadastro" />
                    <p id="RI-Title-Cadastro" >Queixas Atuais:</p>
                    <textarea onChange={this.handleChange} name="current_complaints" placeholder="Queixas Atuais" id="RI-Cadastro" />
                    <p id="RI-Title-Cadastro" >Exames Físicos:</p>
                    <textarea onChange={this.handleChange} name="physical_exam" placeholder="Exames Físicos" id="RI-Cadastro" />
                    <p id="RI-Title-Cadastro" >Exames Complementares:</p>
                    <textarea onChange={this.handleChange} name="complementary_exam" placeholder="Exames Complementares" id="RI-Cadastro" />
                    <p id="RI-Title-Cadastro" >Diagnóstico:</p>
                    <textarea onChange={this.handleChange} name="diagnosis" placeholder="Diagnóstico" id="RI-Cadastro" />
                    <p id="RI-Title-Cadastro" >Conduta:</p>
                    <textarea onChange={this.handleChange} name="conduct" placeholder="Conduta" id="RI-Cadastro" />
                    <p id="RI-Title-Cadastro" >Medicamentos Prescritos:</p>
                    <textarea onChange={this.handleChange} name="prescripted_drugs" placeholder="Medicamentos Prescritos" id="RI-Cadastro" />
                    <p id="RI-Title-Cadastro" >Exames Solicitados:</p>
                    <textarea onChange={this.handleChange} name="requested_exams" placeholder="Exames Solicitados" id="RI-Cadastro" />
                    <p id="RI-Title-Cadastro" >Encaminhamentos:</p>
                    <textarea onChange={this.handleChange} name="medical_referral" placeholder="Encaminhamentos" id="RI-Cadastro" />
                    <p id="RI-Title-Cadastro" >Observações:</p>
                    <textarea onChange={this.handleChange} name="name" placeholder="Observações" id="RI-Cadastro" />
                    <h1 id="tittle-forms-cme">Insira a prescrição para o paciente:</h1>
                    <p id="RI-Title-Cadastro" >Este será o único campo que será visualizado pelo representante de instituição</p>
                    <textarea onChange={this.handleChange} name="prescription" placeholder="(Essa informação será visualizada pelo paciente)" id="RI-Cadastro" />
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <button onClick={() => this.handleSubmit} id="RI-Cadastro">Enviar</button>
                    </div>
                </form>
            </>
        );
    }
}

export default withRouter(Forms_Prontuario_Inicial)